<article class="summary">
  <div class="summary__title"><b>Resumen</b></div>
  <div class="summary__box">
    <div class="summary__box__top">
      <div class="summary__box__top__type">Monto de tu compra</div>
      <div class="summary__box__top__dotline"></div>
      <div class="summary__box__top__value">
        {{ amount | powerpayCurrency }}
      </div>
    </div>
  </div>

  <div class="summary__box">
    <div class="summary__box__top">
      <div class="summary__box__top__type-total">Total a pagar</div>
      <div class="summary__box__top__dotline"></div>
      <div class="summary__box__top__value-total">
        <b>{{ totalToPay | powerpayCurrency }}</b>
      </div>
    </div>
    <div class="summary__box__informative" *ngIf="totalCostWithTaxesInstallment != '0'">
      <p>
        (Incluye comisión Powerpay de {{ totalCostWithTaxesInstallment | powerpayCurrency }} por
        cuota)
      </p>
    </div>
  </div>
</article>

<ng-template #summaryContentTooltip>
  Solo se cobrará, de forma fraccionada,<br />
  esta comisión para los planes de pago de 6<br />
  y 12 cuotas. En el caso del plan de pago de<br />
  3 cuotas, no la cobramos.
</ng-template>
